import TextField, { type TextFieldProps } from '@mui/material/TextField';
import type { AssignedCustomField } from 'services/custom-fields/schemas';

type CustomFieldTextInputProps = TextFieldProps & {
  field: AssignedCustomField;
};

export function CustomFieldTextInput({ field, ...props }: CustomFieldTextInputProps) {
  return (
    <TextField
      label={field.friendlyName}
      variant="outlined"
      size="small"
      fullWidth
      margin="none"
      InputLabelProps={{ disableAnimation: true, shrink: true }}
      {...props}
      inputProps={{
        ...props.inputProps,
        'data-dd-action-name': `Custom Field Editor Input${props.disabled ? ' (disabled)' : ''}`,
      }}
    />
  );
}
